/**
 * Wijmoのライセンスキーを設定する
 * ./app.jsからこれを呼び出した後に各jsxを呼び出すので、
 * Wijmoを使うたびにsetLicenseKeyを実行する必要はない
 */

import * as wjCore from '@mescius/wijmo'

const metaLicense = $('meta[name="wijmo-license"]')
if (metaLicense) {
  wjCore.setLicenseKey(metaLicense.attr('content'))
}
